export const fieldNames = {
  permission: 'permission',
  allow_guests_change_task_status: 'allow_guests_change_task_status',
  assign_guests: 'assign_guests',
  allow_project_summary_email: 'allow_project_summary_email',
  allow_task_done_email: 'allow_task_done_email',
  change_guest_default_column: 'change_guest_default_column'
};

export const guestDefaultColumnName = 'guest_default_column_name';

export const displayColumnName = (name: string) =>
  name ? name.charAt(0).toUpperCase() + name.slice(1) : name;

export const defaultProjectFields = {
  [fieldNames.permission]: true,
  [fieldNames.assign_guests]: true,
  [fieldNames.allow_guests_change_task_status]: true,
  [fieldNames.change_guest_default_column]: false,
  [fieldNames.allow_project_summary_email]: true,
  [fieldNames.allow_task_done_email]: true
};
